import Users from './pages/users/store'

export default {
  namespaced: true,
  modules: {
    Users,
  },
  
}
